import React from "react";
import { IconButton } from "@mui/material";
import { useRecordContext, useSimpleFormIteratorItem } from "react-admin";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

const hasCandidatesByIndex = (index, rooms) => {
  const room = rooms && index >= 0 && index < rooms.length ? rooms[index] : null;
  return room?.candidatesCount && room.candidatesCount > 0;
};

const ExamReOrderButtons = () => {
  const { index, total, reOrder } = useSimpleFormIteratorItem();
  const record = useRecordContext();

  const hasUpward =
    index > 0 && !hasCandidatesByIndex(index - 1, record?.rooms) && !hasCandidatesByIndex(index, record?.rooms);
  const hasDownward =
    total != null &&
    index < total - 1 &&
    !hasCandidatesByIndex(index + 1, record?.rooms) &&
    !hasCandidatesByIndex(index, record?.rooms);

  return (
    <>
      <IconButton
        size="small"
        onClick={() => reOrder(index - 1)}
        disabled={!hasUpward}
      >
        <ArrowUpwardIcon />
      </IconButton>
      <IconButton
        size="small"
        onClick={() => reOrder(index + 1)}
        disabled={!hasDownward}
      >
        <ArrowDownwardIcon />
      </IconButton>
    </>
  );
};

export default ExamReOrderButtons;
